import axios from 'axios'

export interface QHSEFormTemplate {
  id: number
  name: string
  description?: string
  formType?: string
  isActive?: boolean
  isDeleted?: boolean
  companyGroupAdminId?: number
  companyAdminId?: number
}

export interface QHSEFormFieldValuePayload {
  fieldId: number
  valueText: string
}

export interface QHSEFormSubmissionPayload {
  templateId: number
  status?: string
  createdByUserId?: number
  companyGroupAdminId?: number
  companyAdminId?: number
  vesselId?: number
  crewId?: number
  remarks?: string
  values?: QHSEFormFieldValuePayload[]
}

export interface QHSEFormSubmission {
  id: number
  templateId?: number
  status?: string
  createdByUserId?: number
  companyGroupAdminId?: number
  companyAdminId?: number
  vesselId?: number
  crewId?: number
  remarks?: string
  createdAt?: string
  submittedAt?: string
  values?: QHSEFormFieldValuePayload[]
  vesselName?: string
  crewName?: string
  submittedByName?: string
}

const API_URL = process.env.REACT_APP_API_URL || '/api'

export const createQhseFormSubmission = async (
  payload: QHSEFormSubmissionPayload
): Promise<QHSEFormSubmission> => {
  const { data } = await axios.post(`${API_URL}/qhse/forms/submissions/create`, payload)
  return data
}

export const fetchQhseFormSubmissions = async (params?: {
  templateId?: number
  companyGroupId?: number
}): Promise<QHSEFormSubmission[]> => {
  const { data } = await axios.get(`${API_URL}/qhse/forms/submissions`, { params })
  return data
}

export const fetchQhseFormSubmissionById = async (submissionId: number): Promise<QHSEFormSubmission> => {
  const { data } = await axios.get(`${API_URL}/qhse/forms/submissions/${submissionId}`)
  return data
}

export const deleteQhseFormSubmission = async (submissionId: number, params?: { userId?: number }) => {
  await axios.delete(`${API_URL}/qhse/forms/submissions/${submissionId}`, { params })
}
